import { styled } from "@mui/material/styles";

import { Box } from "ui/box/box";
import {
  INFO_MESSAGE_BORDER_COLOR,
  INFO_MESSAGE_BORDER_WIDTH,
  INFO_MESSAGE_COLOR,
  INFO_MESSAGE_GAP,
  INFO_MESSAGE_SIZE,
} from "ui/info-message/info-message.constants";
import {
  type InfoMessageColor,
  type InfoMessageSize,
  type InfoMessageVariant,
} from "ui/info-message/info-message.types";

type InfoMessageRootProps = {
  messageColor: InfoMessageColor;
  messageSize: InfoMessageSize;
  messageVariant: InfoMessageVariant;
};

const ROOT_PROPS: ReadonlyArray<PropertyKey> = ["messageColor", "messageSize", "messageVariant"];

export const InfoMessageRoot = styled(Box, {
  shouldForwardProp: (prop) => !ROOT_PROPS.includes(prop),
})<InfoMessageRootProps>(({ theme, messageColor, messageSize, messageVariant }) => {
  const { glyph, padding, typography } = INFO_MESSAGE_SIZE[messageSize];
  const { lineHeight } = typography(theme);

  return {
    ...typography(theme),
    display: "flex",
    gap: theme.spacing(INFO_MESSAGE_GAP),
    color: INFO_MESSAGE_COLOR[messageColor](theme),

    ...(messageVariant === "outlined" && {
      // Figma draws the stroke inside the padding box, so CSS's border comes out of the padding.
      padding: `calc(${theme.spacing(padding)} - ${INFO_MESSAGE_BORDER_WIDTH}px)`,
      border: `${INFO_MESSAGE_BORDER_WIDTH}px solid ${INFO_MESSAGE_BORDER_COLOR[messageColor](theme)}`,
      borderRadius: theme.shape.medium,
    }),

    "& > svg": {
      flexShrink: 0,
      width: glyph,
      height: glyph,
      marginTop: `calc((${lineHeight} - ${glyph}px) / 2)`,
    },
  };
});
